import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState, TFilterId } from '../../../../../../../../types/types';
import {
    savedFilterSelector
} from '../../../../../../aside_panel/filterPanelBoard/store/selectors/savedFilterSelector';
import {
    savedFilterActionsSet
} from '../../../../../../aside_panel/filterPanelBoard/store/savedFilters/actions/savedFilterActionsSet';
import { metaSet } from '../../../../../../aside_panel/filterPanelBoard/store/filter/actions/metaSet';
import { patchFilter } from '../../../../../../aside_panel/filterPanelBoard/effects/patchFilter';
import {
    savedFilterSet
} from '../../../../../../aside_panel/filterPanelBoard/store/savedFilters/actions/savedFilterSet';

export const onToggleTitle = (
    filterId: TFilterId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const filter = savedFilterSelector(getState(), filterId);
        const isMyWorkHideTitle = !filter.meta.isMyWorkHideTitle;
        dispatch(savedFilterActionsSet(filterId, metaSet({ isMyWorkHideTitle })));
        const newFilter = { ...filter, meta: { ...filter.meta, isMyWorkHideTitle }};
        dispatch(patchFilter(filterId, newFilter)).then(() => {
            dispatch(savedFilterSet(filterId, newFilter));
        });
    }
    return action;
}
